<template>

  <div class="login_wrapper">
    <div class="animate form login_form">
      <section class="login_content">
          <h1>Login</h1>
          <div
            v-if="message" 
            class="alert alert-warning alert-dismissible fade in"
          >
            {{ message }}
          </div>

          <div
            v-if="currentStep === 1" 
          >
            <input 
              v-model="user"
              v-on:keyup.enter="processCurrentStep()"
              type="text"
              class="form-control"
              placeholder="Username"
            />
          </div>

          <div
            v-if="currentStep === 2"
          >
            <input 
              v-model="password" 
              v-on:keyup.enter="processCurrentStep()"
              type="password" 
              class="form-control" 
              placeholder="Password" 
            />
          </div>

          <div>
            <button v-on:click="processCurrentStep()" class="btn btn-default" >Log in</button>
          </div>

          <div class="clearfix"></div>

          <div class="separator">
            <div class="clearfix"></div>
            <div>
              <h1>EDEXIS</h1>
              <p>&copy;2016 All Rights Reserved. EDEXIS</p>
            </div>
          </div>

      </section>
    </div>
  </div>

</template>

<script>
export default {
  name: 'TwoPageAuth',
  data () {
    return {
      user: '',
      password: '',
      message: '',
      currentStep: 1,
      totalSteps: 2,
      appLandingPage: 'tasks'
    }
  },
  mounted () {
    this.$user().isAuthenticated().then(() => {
      // this.$router.push({ name: this.appLandingPage })
      console.log('always returns true')
    }).catch(e => {
      console.log(e)
    })
  },
  methods: {
    processCurrentStep () {
      let method = 'processStep' + this.currentStep

      this[method]().then(response => {
        if (this.currentStep++ === this.totalSteps) {
          this.$router.push({ name: this.appLandingPage })
          return false
        }
        this.$set(this, 'currentStep', this.currentStep++)
      }).catch(e => {
        this.$set(this, 'message', 'Login Attempt Failed')
      })
    },
    processStep1 () {
      return new Promise((resolve, reject) => {
        this.$user().step1(this.user).then(response => {
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    },
    processStep2 () {
      return new Promise((resolve, reject) => {
        this.$user().step2(this.password).then(response => {
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    }
  }
}
</script>

<style>
body {
  background: #F7F7F7 !important;
}
</style>



// WEBPACK FOOTER //
// Phone.vue?541cd87e